import React, { useState } from 'react';
import { Modal } from 'antd';
import '../../assets/css/agendaNueva.css';

const Agenda = () => {

  const [ver_dia, setVerDia] = useState(1);
  const [ver_modal, setVerModal] = useState(false);
  const [select_tema, setSelectTema] = useState(null);

  // 🔥 ACTIVIDADES (AQUÍ YA ESTÁ TODO)
  const agenda = {
    1: [
      {
        hora: '09:00',
        titulo: 'Registro',
        nombre: '',
        tipo: 2
      },
      {
        hora: '10:00',
        titulo: 'Inauguración',
        nombre: '',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '11:00',
        titulo: 'The Adjacent Advantage.',
        nombre: 'Jared Smith',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '12:00',
        titulo: 'Receso - vista stands',
        nombre: '',
        tipo: 2,
        ver_modal: false
      },
      {
        hora: '12:30',
        titulo: 'Iluminando la diversidad.',
        nombre: 'Raquel Quevedo Roldán',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '13:30',
        titulo: 'Receso - vista stands ',
        tipo: 2
      },
      {
        hora: '14:00',
        titulo: 'Lunch* ',
        tipo: 2
      },
      {
        hora: '15:30',
        titulo: 'The Commissioning Process Applied to Lighting and Control Systems.',
        nombre: 'Daniel Salinas',
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '14:30',
        titulo: 'Regulación de la contaminación lumínica en Chile: marco normativo, implementación y lecciones aprendidas.',
        nombre: 'Igor Valdebenito',
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '17:30',
        titulo: 'Mesas redondas estudiantes ',
        nombre: '',
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '19:00',
        titulo: 'Fin del día ',
        nombre: '',
        tipo: 2,
        ver_modal: false
      }
    ],
    2: [
      {
        hora: '10:00',
        titulo: 'Registro',
        nombre: '',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '11:00',
        titulo: 'Entre sombras: la experiencia nocturna del paisaje.',
        nombre: 'Bibiana Davó Sayrols',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '12:00',
        titulo: 'Receso - vista stands',
        tipo: 2
      },
      {
        hora: '12:30',
        titulo: 'Luz como Lenguaje, Diseño como Actitud.',
        nombre: 'Diana Joels',
        tipo: 1,
        ver_modal: false
      },
      {
        hora: '13:30',
        titulo: 'Receso - vista stands',
        tipo: 2
      },
      {
        hora: '14:00',
        titulo: [<>Lunch*</>],
        nombre: '',
        tipo: 2,
        ver_modal: true
      },
      {
        hora: '15:30',
        titulo: '“Iluminación Inteligente en Túneles: Integración, Datos y Control”',
        nombre: 'Gisele Sosa',
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '16:30',
        titulo: 'Invariantes Conceptuales en el Diseño de Iluminación',
        nombre: 'Ignacio Valero',
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '17:30',
        titulo: 'Panel: IES Lighting Intelligence: Ciencia, datos y diseño.',
        nombre: [<>Gabriela Bermeo<br/>
        Emanuelle Christopher Pérez<br />
        Laura Arroyo Rocha<br />
        Brenda Castillo – Moderadora del Panel</>],
        tipo: 1,
        ver_modal: true
      },
      {
        hora: '18:30',
        titulo: 'Clausura y Cocktail',
        nombre: '',
        tipo: 2,
        ver_modal: true
      }
    ]
  };

  const dias_vista = agenda[ver_dia];

  return (
    <div className="agenda_section">

      <h2 className="titulo inter">AGENDA</h2>
      <p className="lugar">Expo Santa Fé</p>

      {/* Tabs */}
      <div className="dias_tabs">
        <button 
          className={ver_dia === 1 ? 'active' : ''} 
          onClick={() => setVerDia(1)}
        >
          MIÉRCOLES 27
        </button>
        <button 
          className={ver_dia === 2 ? 'active' : ''} 
          onClick={() => setVerDia(2)}
        >
          JUEVES 28
        </button>
      </div>

      {/* Timeline */}
      <div className="timeline">

        {dias_vista.map((item, index) => (
          <div key={index} className="timeline_item">

            <div className="hora">
              {item.hora}
            </div>

            <div 
              className={`card ${item.tipo === 2 ? 'break' : ''}`}
              onClick={() => item.ver_modal && (setSelectTema(index), setVerModal(true))}
            >
              <h3>{item.titulo}</h3>

              {item.nombre && (
                <p className="ponente">{item.nombre}</p>
              )}

              {item.ver_modal && (
                <span className="ver">Leer más</span>
              )}
            </div>

          </div>
        ))}

      </div>

      <p className="nota">
        * No incluye servicio de lunch<br />
        **Todos los horarios y contenido están sujetos a cambios<br />
        
      </p>

      {/* MODAL 
      <Modal
        open={ver_modal}
        onCancel={() => setVerModal(false)}
        footer={null}
        centered
      >
        <h3>{dias_vista[select_tema]?.titulo}</h3>
        <p>{dias_vista[select_tema]?.nombre}</p>
        <p>Aquí puedes poner descripción completa del evento.</p>
      </Modal>*/}

    </div>
  );
};

export default Agenda;